import useController from '@common/hooks/useController'

// Native shim — read state from in-process ControllerStore.
// Web variant relies on `FeatureFlagsControllerStateProvider` not mounted on RN.
export default function useFeatureFlagsControllerState(): any {
  const { state } = useController('FeatureFlagsController' as any)
  return state as any
}
